import React, { useEffect, useRef } from 'react';
import './Knowledge.css';

const Knowledge = () => {
  const primaryCarouselRef = useRef<HTMLDivElement>(null);
  const secondaryCarouselRef = useRef<HTMLDivElement>(null);
  const tertiaryCarouselRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      const rate = scrolled * -0.1; // Gentle movement rate
      
      if (primaryCarouselRef.current) {
        primaryCarouselRef.current.style.transform = `translateX(${rate}px)`;
      }
      
      if (secondaryCarouselRef.current) {
        secondaryCarouselRef.current.style.transform = `translateX(${-rate}px)`; // Opposite direction
      }
      
      if (tertiaryCarouselRef.current) {
        tertiaryCarouselRef.current.style.transform = `translateX(${rate}px)`; // Same as primary
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const primaryItems = [
    'Energy Performance',
    'Legal Requirements',
    'Planning Control',
    'Fire Safety',
    'Building Regulations',
    'Climate Resources'
  ];

  const secondaryItems = [
    'Professional Practice',
    'Heritage Conservation',
    'Design Precedents',
    'Planning References',
    'Software Standards'
  ];

  const tertiaryItems = [
    'Contract Materials',
    'Procurement Methods',
    'Safety Protocols',
    'Property Law',
    'Digital Resources'
  ];

  return (
    <div className="knowledge" id="knowledge">
      <div className="knowledge-container">
        <div className="knowledge-header">
          <h2 className="knowledge-title">Instant code compliance.</h2>
          <p className="knowledge-subtitle">
          We have built the first live, worldwide architectural compliance database to clause-level detail. Our AI is rigorously trained on this data to provide accurate, fully cited decisions for every project. 
          </p>
        </div>
      </div>
      
      <div className="knowledge-carousels-container">
        <div className="knowledge-carousels">
          <div className="carousel-wrapper">
            <div className="carousel primary-carousel" ref={primaryCarouselRef}>
              {/* Render items multiple times for seamless infinite scroll on desktop */}
              {[...Array(4)].map((_, repeatIndex) => (
                <React.Fragment key={`repeat-${repeatIndex}`}>
                  {primaryItems.map((item, index) => (
                    <div key={`${repeatIndex}-${index}`} className="carousel-item">
                      {item}
                    </div>
                  ))}
                </React.Fragment>
              ))}
            </div>
          </div>
          
          <div className="carousel-wrapper">
            <div className="carousel secondary-carousel" ref={secondaryCarouselRef}>
              {/* Render items multiple times for seamless infinite scroll on desktop */}
              {[...Array(4)].map((_, repeatIndex) => (
                <React.Fragment key={`repeat-${repeatIndex}`}>
                  {secondaryItems.map((item, index) => (
                    <div key={`${repeatIndex}-${index}`} className="carousel-item">
                      {item}
                    </div>
                  ))}
                </React.Fragment>
              ))}
            </div>
          </div>
          
          <div className="carousel-wrapper tertiary-wrapper">
            <div className="carousel tertiary-carousel" ref={tertiaryCarouselRef}>
              {/* Render items multiple times for seamless infinite scroll on desktop */}
              {[...Array(4)].map((_, repeatIndex) => (
                <React.Fragment key={`repeat-${repeatIndex}`}>
                  {tertiaryItems.map((item, index) => (
                    <div key={`${repeatIndex}-${index}`} className="carousel-item">
                      {item}
                    </div>
                  ))}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Knowledge; 